import AddAddressContainer from 'modules/order/containers/AddAddressContainer';

const AddAddressView = () => <AddAddressContainer />;

export default AddAddressView;
